import moment from 'moment';
import {
  ALL,
  DISPUTES,
  INCIDENTS,
  PAYMENT_FORMS,
  DEFAULT,
  GATEWAYS_CONFIGURATION,
  ROUTER,
  OFFERSV2,
  INTELLI_FORMS,
} from 'utils/constants';
import { ACTIVE, UPCOMING, RESOLVED } from '../PgIncidents/constants';
import {
  CURRENT_DATE_RANGE_BATCH,
  NEXT_DATE_RANGE_BATCH,
  PREV_DATE_RANGE_BATCH,
} from './constants';

export const modifyDefaultDateOptions = (
  menuSelected,
  activeNavigation,
  defaultDateOptions,
  filters,
) => {
  if (
    menuSelected === PAYMENT_FORMS &&
    [ALL, INTELLI_FORMS].includes(activeNavigation)
  ) {
    defaultDateOptions.unshift({
      displayText: 'All time',
      range: [
        moment()
          .startOf('year')
          .toDate(),
        moment()
          .endOf('day')
          .toDate(),
      ],
    });
  } else if (
    menuSelected === ROUTER &&
    activeNavigation === GATEWAYS_CONFIGURATION
  ) {
    const SELECTED_DATE_RANGE_BATCH = [
      {
        displayText: 'All time',
        range: CURRENT_DATE_RANGE_BATCH[0].range,
      },
      {
        displayText: 'Today',
        range: CURRENT_DATE_RANGE_BATCH[1].range,
      },
      {
        displayText: 'Last 7 days',
        range: PREV_DATE_RANGE_BATCH[2].range,
      },
      {
        displayText: 'This Month',
        range: CURRENT_DATE_RANGE_BATCH[2].range,
      },
      {
        displayText: 'Last Month',
        range: PREV_DATE_RANGE_BATCH[3].range,
      },
    ];

    defaultDateOptions.splice(
      0,
      defaultDateOptions.length,
      ...SELECTED_DATE_RANGE_BATCH,
    );
  } else if (menuSelected === DISPUTES) {
    defaultDateOptions.push({
      displayText: 'Last 6 Months',
      range: [
        moment()
          .subtract(6, 'months')
          .startOf('day')
          .toDate(),
        moment()
          .endOf('day')
          .toDate(),
      ],
    });
    defaultDateOptions.push({
      displayText: 'Last 1 Year',
      range: [
        moment()
          .subtract(1, 'year')
          .startOf('day')
          .toDate(),
        moment()
          .endOf('day')
          .toDate(),
      ],
    });
  }  else if (menuSelected === INCIDENTS) {
    const status = filters?.appliedFilters?.status || DEFAULT;
    switch (status) {
      case ACTIVE:
      case RESOLVED: {
        defaultDateOptions.splice(
          0,
          defaultDateOptions.length,
          ...applyBoundOnTime(
            CURRENT_DATE_RANGE_BATCH,
            null,
            moment().toDate(),
          ),
          ...PREV_DATE_RANGE_BATCH,
        );
        break;
      }
      case UPCOMING: {
        defaultDateOptions.splice(
          0,
          defaultDateOptions.length,
          ...applyBoundOnTime(
            CURRENT_DATE_RANGE_BATCH,
            moment().toDate(),
            null,
          ),
          ...NEXT_DATE_RANGE_BATCH,
        );
        break;
      }
      case DEFAULT: {
        // Remove all elements from the array
        defaultDateOptions.splice(
          0,
          defaultDateOptions.length,
          ...CURRENT_DATE_RANGE_BATCH,
          ...PREV_DATE_RANGE_BATCH,
          ...NEXT_DATE_RANGE_BATCH,
        );
        break;
      }
      default:
        break;
    }
  } else if (menuSelected === OFFERSV2 && activeNavigation === ALL) {
    defaultDateOptions.push({
      displayText: 'Last 1 Year',
      range: [
        moment()
          .subtract(1, 'year')
          .startOf('day')
          .toDate(),
        moment()
          .endOf('day')
          .toDate(),
      ],
    });
  }
};

export const applyBoundOnTime = (objArray, startTime, endTime) =>
  objArray.map(item => {
    const newItem = { ...item };
    // Create a deep copy of the range array
    newItem.range = [...newItem.range];

    if (startTime) newItem.range[0] = startTime;
    else if (endTime) newItem.range[1] = endTime;

    return newItem;
  });
